export const DATA_TEST_ID = 'high-school-preview-banner'
